import {
  GET_CLASSROOM_FAILED_CC,
  GET_CLASSROOM_SUCCESS_CC,
  GET_CURRICULUM_FAILED,
  GET_CURRICULUM_SUCCESS,
  GET_SITE_FAILED_CC,
  GET_SITE_FAILED_CU,
  GET_SITE_SUCCESS_CC,
  GET_SITE_SUCCESS_CU,
  START_LOADING,
  STOP_LOADING,
} from "../actionConstants";
import { AppDispatch } from "../store";
import { postWithOther } from "./axios";

export const getSitesDetailsFromCorC =
  (body: any) => async (dispatch: AppDispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const result = await postWithOther(
        `${
          process.env.REACT_APP_ENV === "local"
            ? ""
            : process.env.REACT_APP_COR_C_URL
        }/api/admin/sso`,
        body,
        dispatch
      );

      if (result) {
        dispatch({
          type: GET_SITE_SUCCESS_CC,
          payload: result,
        });
      }
    } catch (err) {
      dispatch({
        type: GET_SITE_FAILED_CC,
      });
    } finally {
      dispatch({ type: STOP_LOADING });
    }
  };

export const getSitesDetailsFromCorCu =
  (body: any) => async (dispatch: AppDispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const result = await postWithOther(
        `${
          process.env.REACT_APP_ENV === "local"
            ? ""
            : process.env.REACT_APP_CURR_URL
        }/api/admin/sso`,
        body,
        dispatch
      );

      if (result) {
        dispatch({
          type: GET_SITE_SUCCESS_CU,
          payload: result,
        });
      }
    } catch (err) {
      dispatch({
        type: GET_SITE_FAILED_CU,
      });
    } finally {
      dispatch({ type: STOP_LOADING });
    }
  };

export const getClassroomDetailsFromCorC =
  (body: any) => async (dispatch: AppDispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const result = await postWithOther(
        `${
          process.env.REACT_APP_ENV === "local"
            ? ""
            : process.env.REACT_APP_COR_C_URL
        }/api/admin/sso`,
        body,
        dispatch
      );

      if (result) {
        dispatch({
          type: GET_CLASSROOM_SUCCESS_CC,
          payload: result,
        });
      }
    } catch (err) {
      dispatch({
        type: GET_CLASSROOM_FAILED_CC,
      });
    } finally {
      dispatch({ type: STOP_LOADING });
    }
  };

export const getClassroomDetailsFromCorCu =
  (body: any) => async (dispatch: AppDispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const result = await postWithOther(
        `${
          process.env.REACT_APP_ENV === "local"
            ? ""
            : process.env.REACT_APP_CURR_URL
        }/api/admin/sso`,
        body,
        dispatch
      );

      if (result) {
        dispatch({
          type: GET_CURRICULUM_SUCCESS,
          payload: result,
        });
      }
    } catch (err) {
      dispatch({
        type: GET_CURRICULUM_FAILED,
      });
    } finally {
      dispatch({ type: STOP_LOADING });
    }
  };
